import React, { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsappFloat = () => {
  const [bottomPosition, setBottomPosition] = useState(80);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    let timeoutId = null;

    const handleScroll = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        const footer = document.getElementById('footer');
        if (!footer) return;

        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        const buttonHeight = isMobile ? 48 : 60; // ajustar botón para móvil

        const distanceToFooter = windowHeight - footerTop;

        if (distanceToFooter > 0) {
          setBottomPosition(distanceToFooter + 20);
        } else {
          setBottomPosition(isMobile ? 20 : 80);
        }
      }, 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
      handleScroll();
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    handleResize(); // Ejecutar al montar para detectar móvil y calcular posición

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [isMobile]);

  return (
    <a
      href="https://wa.me/34666290795"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: `${bottomPosition}px`,
        right: isMobile ? '12px' : '20px',
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '50%',
        width: isMobile ? '48px' : '60px',
        height: isMobile ? '48px' : '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        zIndex: 1000,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, bottom 0.3s ease',
        textDecoration: 'none',
      }}
      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#128C4A')}
      onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#25D366')}
      aria-label="Chat WhatsApp"
    >
      <FaWhatsapp size={isMobile ? 24 : 30} />
    </a>
  );
};

export default WhatsappFloat;
